<template>
    <ul class="tabbed-view-tabs">
        <li v-for="tab in tabs" :key="tab" :class="{ 'is-active': casedActive === tab }" @click="clicked(tab)">
            <slot :name="getTabSlotName(tab)" :tab="tab">
                <span>{{ tab }}</span>
            </slot>
        </li>
    </ul>
</template>
<script setup>
import { computed } from 'vue'

function getSlotName(tabName) {
    return tabName.replace(/[^0-9a-zA-Z]+/g, '-').toLowerCase()
}

const props = defineProps({
    active: String,
    tabs: {
        type: Array,
        default: () => [],
    },
})

const emit = defineEmits(['update:active'])

function clicked(tab) {
    emit('update:active', tab)
}

function getTabSlotName(tab) {
    return `${getSlotName(tab)}-tab`
}

const casedActive = computed(() => {
    if (!props.tabs || props.tabs.length === 0) {
        return null
    }

    let tab = props.tabs.find(tab => {
        return tab.localeCompare(props.active || '', 'en', { sensitivity: 'base' }) == 0
    })

    if (!tab) {
        tab = props.tabs[0]
        clicked(tab)
    }

    return tab
})
</script>
<style scoped>
ul {
    display: flex;
    flex-wrap: wrap;
}

li {
    background-color: var(--color-primary-100);
    color: var(--color-primary-600);
    cursor: pointer;
    display: inline-block;
    font-size: var(--font-size-tab-text);
    font-weight: bold;
    line-height: 16px;
    margin-right: 4px;
    margin-bottom: 8px;
    padding: 16px 24px;
    text-transform: uppercase;
    user-select: none;
    white-space: nowrap;

    &:hover {
        background-color: var(--color-primary-200);
    }

    &.is-active {
        background-color: var(--color-dark);
        color: var(--color-light);
    }
}

ul.light {
    --light-border-size: 4px;

    border-bottom: var(--light-border-size) solid var(--color-primary-200);
    width: 100%;
}

ul.light li {
    background-color: transparent;
    font-size: var(--font-size-label-text);
    line-height: var(--font-size-label-text);
    margin-bottom: calc(-1 * var(--light-border-size));
    margin-right: 16px;
    text-transform: none;
}

ul.light li.is-active {
    background-color: transparent;
    border-bottom: var(--light-border-size) solid var(--color-active);
    color: var(--color-primary-600);
}
</style>
